import { ITEMS_GEAR_PACK, ITEMS_RARITY, ItemTemplate } from "../constants";

export default {
    type: "gear_packs",
    listData: [{
        "key": "name",
        "label": "Name",
    }, {
        "key": "rarity",
        "label": "Rarity",
    }, {
        "key": "amount",
        "label": "Amount",
    }, {
        "key": "price",
        "label": "Price",
    }],
    template: [{
        "key": "name",
        "label": "Name",
        "type": "input",
    }, {
        "key": "game_id",
        "label": "Game Id",
        "type": "input",
        "format": "integer"
    }, {
        "key": "amount",
        "label": "Pack amount",
        "type": "input",
        "format": "integer",
        "disabled": true
    }, {
        "key": "rarity",
        "label": "Rarity",
        "type": "select",
        "values": ITEMS_RARITY
    }, {
        "key": "price",
        "label": "Price",
        "type": "input",
        "format": "integer"
    }, {
        "key": "gear_item_id",
        "label": "Item",
        "type": "select",
        "values": ITEMS_GEAR_PACK
    }]
} as ItemTemplate;
